import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  return params.toString();
}

export async function fetchFundingLenders(filters = {}) {
  const params = new URLSearchParams();
  if (filters.lenderType) params.set('type', filters.lenderType);
  if (filters.productType) params.set('product_type', filters.productType);
  if (filters.state) params.set('state', filters.state);
  if (filters.search) params.set('search', filters.search);
  if (filters.status) params.set('status', filters.status);
  if (filters.minCreditScore != null) params.set('min_credit_score', String(filters.minCreditScore));
  if (filters.maxRequestedAmount != null) params.set('max_requested_amount', String(filters.maxRequestedAmount));
  if (filters.featured != null) params.set('featured', String(filters.featured));
  if (filters.acceptsLowCredit != null) params.set('accepts_low_credit', String(filters.acceptsLowCredit));
  if (filters.acceptsStartups != null) params.set('accepts_startups', String(filters.acceptsStartups));
  if (filters.commissionAvailable != null) params.set('commission_available', String(filters.commissionAvailable));

  const query = params.toString();
  const data = await fundingHqFetch(`/lenders${query ? `?${query}` : ''}`);
  return {
    lenders: data.lenders ?? [],
    total: data.total ?? (data.lenders?.length ?? 0),
  };
}

export async function fetchFundingLender(lenderId, agencyId) {
  const query = agencyQuery(agencyId);
  return fundingHqFetch(`/lenders/${encodeURIComponent(lenderId)}${query ? `?${query}` : ''}`);
}

export async function createFundingLender(payload) {
  return fundingHqFetch('/lenders', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function updateFundingLender(lenderId, payload) {
  return fundingHqFetch(`/lenders/${encodeURIComponent(lenderId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function archiveFundingLender(lenderId) {
  return fundingHqFetch(`/lenders/${encodeURIComponent(lenderId)}`, { method: 'DELETE' });
}

export async function createFundingLenderProduct(lenderId, payload) {
  return fundingHqFetch(`/lenders/${encodeURIComponent(lenderId)}/products`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function updateFundingLenderProduct(lenderId, productId, payload) {
  return fundingHqFetch(`/lenders/${encodeURIComponent(lenderId)}/products/${encodeURIComponent(productId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function deleteFundingLenderProduct(lenderId, productId) {
  return fundingHqFetch(`/lenders/${encodeURIComponent(lenderId)}/products/${encodeURIComponent(productId)}`, {
    method: 'DELETE',
  });
}
